var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20564_166812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60481 7.16898C1.60447 8.38831 1.92307 9.57889 2.52889 10.6283L1.54688 14.2138L5.21618 13.2517C6.23106 13.8042 7.36816 14.0937 8.52367 14.0937H8.52671C12.3413 14.0937 15.4465 10.9897 15.4481 7.17443C15.4488 5.32566 14.7295 3.5872 13.4226 2.27928C12.1159 0.971463 10.3781 0.250844 8.52643 0.25C4.71139 0.25 1.60644 3.35388 1.60487 7.16898",
    fill: "url(#paint0_linear_20564_166812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35706 7.16715C1.35667 8.43036 1.68669 9.66353 2.3141 10.7505L1.29688 14.4645L5.09774 13.4679C6.14501 14.0389 7.32412 14.34 8.52393 14.3404H8.52703C12.4785 14.3404 15.6952 11.1247 15.6969 7.17289C15.6976 5.25769 14.9524 3.45673 13.5988 2.10195C12.245 0.747337 10.445 0.0007875 8.52703 0C4.5749 0 1.35864 3.21525 1.35706 7.16715ZM3.62062 10.5633L3.4787 10.338C2.88211 9.38942 2.56723 8.29322 2.56768 7.1676C2.56891 3.88288 5.24214 1.2105 8.52928 1.2105C10.1212 1.21118 11.6172 1.83173 12.7424 2.95763C13.8676 4.08364 14.4867 5.58045 14.4863 7.17244C14.4849 10.4572 11.8116 13.1299 8.52703 13.1299H8.52466C7.45518 13.1293 6.40629 12.8421 5.49155 12.2993L5.27386 12.1703L3.01835 12.7616L3.62062 10.5633Z",
    fill: "url(#paint1_linear_20564_166812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.734 4.17309C6.59979 3.87479 6.45854 3.86877 6.33091 3.86354C6.2264 3.85904 6.10692 3.85938 5.98756 3.85938C5.86809 3.85938 5.67397 3.90432 5.50989 4.08348C5.34564 4.26281 4.88281 4.69616 4.88281 5.57754C4.88281 6.45892 5.52479 7.31077 5.61429 7.43041C5.70389 7.54983 6.85364 9.41643 8.67457 10.1345C10.1879 10.7313 10.4959 10.6126 10.8243 10.5827C11.1528 10.5528 11.8843 10.1494 12.0335 9.73109C12.1829 9.31282 12.1829 8.95428 12.1381 8.87936C12.0933 8.80471 11.9739 8.75988 11.7947 8.67033C11.6155 8.58078 10.7347 8.14732 10.5705 8.08753C10.4063 8.02779 10.2869 7.99798 10.1674 8.17736C10.0479 8.35646 9.70484 8.75988 9.60027 8.87936C9.49582 8.99911 9.39125 9.01402 9.21215 8.92441C9.03288 8.83452 8.45592 8.64558 7.77142 8.03532C7.23884 7.56046 6.87929 6.97406 6.77478 6.79467C6.67027 6.61557 6.76359 6.51849 6.85342 6.42922C6.93391 6.34895 7.03263 6.22002 7.12229 6.11546C7.21162 6.01083 7.24143 5.93619 7.30117 5.81671C7.36096 5.69712 7.33104 5.5925 7.28632 5.50289C7.24143 5.41329 6.8933 4.52729 6.734 4.17309Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20564_166812",
    x1: 696.609,
    y1: 1396.63,
    x2: 696.609,
    y2: 0.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20564_166812",
    x1: 721.297,
    y1: 1446.45,
    x2: 721.297,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20564_166812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.5125,
    fill: "white",
    transform: "translate(1.29688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.9f41f1e1a6c0814954df7e088177b5d3.svg";
export { ForwardRef as ReactComponent };